import { createContext } from 'react';

const useProductAllocationContext = createContext();
export default useProductAllocationContext;
